<template>
  <div class="shopping-submited">
    <div class="main-width page-inner">
      <div class="page-inner-header">
        <div class="page-inner-title">
          <img src="../../assets/icons/paper1.png" style="width:28px" alt="">
          <span class="custom-control-inline" style="margin-left: 1rem">订单提交成功，正在等待平台客服确认。</span>
        </div>
      </div>
      <div class="left-space">
        <span class="custom-control-inline" style="width:106px">订购单号：</span>
        <span class="custom-control-inline"><strong>{{this.$route.params.number}}</strong></span>
      </div>
      <div class="left-space">
        <span class="custom-control-inline" style="width:106px">订单金额：</span>
        <span class="custom-control-inline"><strong>￥{{this.$route.params.amount}}</strong></span>
      </div>
      <div class="left-space">
        <span class="custom-control-inline" style="width:106px">应预付金额：</span>
        <span class="custom-control-inline"><strong>￥{{this.$route.params.amount}}</strong></span>
      </div>
      <div class="left-space">
        <span class="custom-control-inline" style="width:106px">货款支付：</span>
        <span class="custom-control-inline"><strong>{{this.$route.params.paymentMode}}</strong></span>
      </div>
      <div class="left-space" style="padding: 30px 0 40px">
        为确保您的采购订单可尽快交付，<br>
        平台客服可能通过 <strong>400-000-123</strong> 与您联系确认订购事宜，敬请留意。
      </div>
      <div class="left-space">
        <button class="ap-btn ap-btn-darkred ap-btn-middle" @click="viewDetail"><strong>查看我的订单</strong></button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      viewDetail() {
        this.$router.push('/buyer/order/');
      }
    },
    created(){
      document.title = '51 AUTOPARTS 订单提交成功'
    }
  }
</script>
<style lang="less">
  .shopping-submited {
    padding:12px 0;
    background:#f2f2f2;

    .left-space {
      margin-left: (28 + 16)/16rem;
    }
  }
</style>